import { useEffect } from "react"
import { usePageTitleStore } from "@stores/pageTitleStore"

export const usePageTitle = (title?: string) => {
	const { title: currentTitle, setTitle, clearTitle } = usePageTitleStore()

	// Update title when the title parameter changes
	useEffect(() => {
		if (title !== undefined) {
			setTitle(title)
		}
	}, [title, setTitle])

	return {
		setCurrentTitle: setTitle,
		clearCurrentTitle: clearTitle,
		currentTitle
	}
}
